// extracted by mini-css-extract-plugin
module.exports = {"container":"receipt-list_container__S_ajY","receiptButton":"receipt-list_receiptButton__wGVjr"};